module.exports = __webpack_public_path__ + "static/media/music.3a9ddb78.svg";